import React from 'react';
import './Schedule.scss';

// small component used for us to decide which piece of information in the event we want to display on the
// calendar, in this case we only display the user name and title
// カレンダーに表示されるイベント

//
//<div style={{overflow: 'hidden'}}>
//    <p className='event_title'>{title}</p>
//</div>
export const CalendarEvent = ({event}) => {

    const {title} = event;

  return (
        <p className='event_title'>{title}</p>
  )
}
